"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpCurriculumImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var constants_1 = require("../../../api/constants");
var logo_em_svg_1 = __importDefault(require("./assets/logo-em.svg"));
var logo_ww_svg_1 = __importDefault(require("./assets/logo-ww.svg"));
var logo_phd_svg_1 = __importDefault(require("./assets/logo-phd.svg"));
var image_1 = __importDefault(require("next/image"));
var logo_geo_svg_1 = __importDefault(require("./assets/logo-geo.svg"));
var curriculumImage = (_a = {},
    _a[constants_1.CurriculumId.EurekaMath] = logo_em_svg_1.default,
    _a[constants_1.CurriculumId.WitAndWisdom] = logo_ww_svg_1.default,
    _a[constants_1.CurriculumId.PhDScience] = logo_phd_svg_1.default,
    _a[constants_1.CurriculumId.Geodes] = logo_geo_svg_1.default,
    _a);
var DpCurriculumImage = function (_a) {
    var curriculum = _a.curriculum;
    // --------------------------------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return ((0, jsx_runtime_1.jsx)(image_1.default, { src: curriculumImage[curriculum], "data-name": curriculum, alt: "".concat(t("DpCurriculumImage.".concat(curriculum)), " ").concat(t('logo')), width: 70, height: 28 }));
};
exports.DpCurriculumImage = DpCurriculumImage;
exports.default = exports.DpCurriculumImage;
